import $ from "jquery";
import numeral from "numeral";

import LocalDB from "../utils/localDB";

export const fetchGoods = () => {
  const { selected_goods = [] } = LocalDB.fetch("mci_form") || {};
  return selected_goods;
};

export const validateGoods = (good, goodsList) => {
  let error = true,
    message = "";

  if (good.section_id === "") {
    message = "You haven't selected a section";
  } else if (good.goods_description === "") {
    message = "Enter the description of goods";
  } else if (good.goods_value === "") {
    message = "Enter the value of goods";
  } else if (good.unit_of_measure === "" || good.quantity === "") {
    message = "Enter the unit of measure and quantity";
  } else if (goodExists(goodsList, good)) {
    message = "This good is already in the goods list";
  } else {
    error = false;
  }

  return { error, message };
};

export const goodExists = (goods_list, good) => {
  return (
    goods_list.filter(_good => {
      return (
        _good.section_id === good.section_id &&
        _good.goods_description === good.goods_description
      );
    }).length > 0
  );
};

export const addGood = goods_list => {
  let goods_value = $("input[name=goods_value]"),
    section_box = $("select[name=sections_list] option:selected"),
    goods_description = $("textarea[name=goods_description]"),
    unit_of_measure = $("select[name=unit_of_measure] option:selected"),
    quantity = $("input[name=goods_quantity]"),
    good_item = {
      section: section_box.text(),
      section_id: section_box.val(),
      goods_value: numeral(goods_value.val()).value(),
      goods_description: goods_description.val(),
      unit_of_measure: unit_of_measure.val(),
      quantity: quantity.val(),

      vat: section_box.data("vat"),
      excise_duty: section_box.data("excise-duty"),
      import_duty: section_box.data("import-duty")
    };

  if (good_item.section_id === "") {
    alert("You haven't selected a section");
  } else if (good_item.goods_description === "") {
    alert("Enter the description of goods");
  } else if (good_item.goods_value === "") {
    alert("Enter the value of goods");
  } else if (good_item.unit_of_measure === "" || good_item.quantity === "") {
    alert("Enter the unit of measure and quantity");
  } else if (goodExists(goods_list, good_item)) {
    alert("This good is already in the goods list");
  } else {
    goods_list.push(good_item);

    return goods_list;
  }

  return false;
};

export const removeGood = (goods_list, good) => {
  return goods_list.filter(function(_good, index) {
    return (
      _good.section_id !== good.section_id &&
      _good.goods_description !== good.goods_description
    );
  });
};

export const editGood = goods_list => {
  let section_box = $("select[name=sections_list] option:selected"),
    goods_description = $("textarea[name=goods_description]"),
    unit_of_measure = $("select[name=unit_of_measure] option:selected"),
    goods_quantity = $("input[name=goods_quantity]"),
    good_item = {
      section: section_box.val(),
      section_name: section_box.text(),
      description: goods_description.val(),
      unit_qty: unit_of_measure.val(),
      quantity: goods_quantity.val()
    };

  if (good_item.section === "") {
    alert("You haven't selected a section");
  } else if (good_item.description === "") {
    alert("Enter the description of goods");
  } else if (good_item.unit_qty === "" || good_item.quantity === "") {
    alert("Enter the unit of measure and quantity");
  } else if (editGoodExists(goods_list, good_item)) {
    alert("This good is already in the goods list");
  } else {
    goods_list.push(good_item);

    return goods_list;
  }

  return false;
};

export const editGoodExists = (goods_list, good) => {
  return (
    goods_list.filter(_good => {
      return (
        _good.section === good.section && _good.description === good.description
      );
    }).length > 0
  );
};

export const editRemoveGood = (goods_list, good) => {
  return goods_list.filter(function(_good, index) {
    return (
      _good.section !== good.section && _good.description !== good.description
    );
  });
};



// WEBPACK FOOTER //
// ./src/utils/good-utils.js